import { useTranslation } from "react-i18next";
import P, { P2 } from "../../../components/Paragraph";
import Widget from "../Widget";
import DonutChart from "./DonutChart";
import useStatisticsWidget from "./useStatisticsWidget";
import useIsMobile from "../../../hooks/useIsMobile";

const colors = {
  READY: "#865c08",
  FINISHED: "#385654",
};

const StatisticsWidget = () => {
  const { t } = useTranslation();
  const { chartData, dialogsData, isLoading } = useStatisticsWidget();
  const isMobile = useIsMobile();

  const legend = {
    READY: t("statistics.unfinished"),
    FINISHED: t("statistics.finished"),
  };

  if (isMobile === true) return null;

  return (
    <Widget header={t("nav.statistics")} isLoading={isLoading} centered lastWidget>
      <>
        <P>{t("statistics.problemsTackled")}</P>
        <DonutChart data={dialogsData} />
        {chartData?.map((chartItem) => {
          return (
            <P2 key={chartItem?.status}>
              <b
                style={{ color: colors[chartItem?.status] }}
              >{`${chartItem?.percentage}%`}</b>
              {` ${legend[chartItem?.status]}`}
            </P2>
          );
        })}
      </>
    </Widget>
  );
};

export default StatisticsWidget;
